module.exports = __webpack_public_path__ + "img/central.f2ba334d.png";